module.exports = __webpack_public_path__ + "static/img/qxb.854da5d.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/h5/qxb.webp
// module id = ysfQ
// module chunks = 2